import * as React from 'react'

import { palette } from 'main/ui'
import { SVGResponsive } from './common'

function Question() {
  return (
    <SVGResponsive height={24} width={24}>
      <circle cx="12" cy="12" r="12" fill={palette.skyBlue2} />
      <path
        d="M10.61 14.554V15.31H12.662V14.698C12.662 13.582 13.04 12.988 13.94 12.322C15.092 11.422 15.722 10.738 15.722 9.316C15.722 7.372 14.39 6.22 12.194 6.22C9.548 6.22 8.612 8.038 8.558 9.658H10.628C10.736 8.794 11.222 8.164 12.194 8.164C13.076 8.164 13.616 8.668 13.616 9.442C13.616 10.144 13.292 10.54 12.194 11.332C10.844 12.304 10.61 13.348 10.61 14.554ZM11.69 19.09C12.446 19.09 13.058 18.478 13.058 17.722C13.058 16.948 12.446 16.336 11.69 16.336C10.952 16.336 10.322 16.948 10.322 17.722C10.322 18.478 10.952 19.09 11.69 19.09Z"
        fill={palette.white}
      />
    </SVGResponsive>
  )
}

export default React.memo(Question)
